<template>
  <div class="container">
    <div class="course">
      <div class="left">
        <img :src="coverSrc" alt="" />
      </div>
      <div class="right">
        <h3>{{ courseName }}</h3>
        <div class="info">
          <div class="left">学员 : {{ count }}人</div>
          <!-- <div class="right">
            批次/班级 : 2021001 <br />
            开课时间 : 2021-06-12 <br />
            结课时间 : 2021-08-19
          </div> -->
        </div>
      </div>
    </div>

    <div class="student">
      <div class="header">
        <div class="title">课程学员</div>
        <div class="btn">
          <el-button
            v-if="type == 1"
            :type="orderBy === 'descs' || orderBy === 'ascs' ? 'primary' : ''"
            size="small"
            @click="sortByProgress"
          >
            进度排序
          </el-button>
          <el-button
            v-if="type == 1"
            :type="orderBy === 'desc' || orderBy === 'asc' ? 'primary' : ''"
            size="small"
            @click="sortByScore"
          >
            优秀排序
          </el-button>
        </div>
      </div>
      <div class="stu_list" v-for="item in courseStudentList" :key="item.id">
        <div class="stu_item">
          <div class="left">
            <img class="pic" src="@/static/images/middle.jpg" alt="" />
            <div class="info">
              <div>{{ item.uname }}</div>
              <div>
                <div v-if="item.intro !== null">{{ item.intro }}</div>
                <div v-else>这个人很懒,什么都没有留下...</div>
              </div>
              <div class="time">时间: {{ item.ctime | showDate }}</div>
            </div>
          </div>

          <div class="right">
            <div v-if="type == 1">
              <div class="top">
                <div class="score">
                  成绩 : <span class="num">{{ item.finalScore }}分</span>
                </div>
                <div class="tips" @click="showTipsDialog(item.uname, item.uid)">
                  督学
                </div>
              </div>
              <div class="mid" :class="item.isFailScore ? 'failScore' : ''">
                <el-progress
                  :show-text="false"
                  :stroke-width="24"
                  :percentage="item.width"
                  :color="item.color"
                ></el-progress>
              </div>
              <div class="bottom">
                <div
                  class="learning_record"
                  @click="showLearningRecordDialog(item.uname, item.uid)"
                >
                  学习记录
                </div>
                <div
                  class="examine_result"
                  @click="showExamineResultDialog(item.uname, item.uid)"
                >
                  考核结果
                </div>
              </div>
            </div>
            <div v-if="type == 2 || type == 3">
              <div
                class="attendance_result"
                @click="showAttendanceResultDialog(item.uname, item.uid)"
              >
                考勤结果
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageObj.page"
        :page-size="pageObj.pageSize"
        layout="prev, pager, next"
        prev-text=" 上一页 "
        next-text=" 下一页 "
        background
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="uname + ' 的督学信息:'"
      :visible.sync="tipsDialog"
      width="560px"
      @close="closeTipsDialog"
    >
      <el-form ref="tipsForm" :rules="tipsFormRules" :model="superintendent">
        <el-form-item prop="content">
          <el-input
            type="textarea"
            :rows="4"
            v-model="superintendent.content"
            @input="tipsTextareaChange"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <div v-for="(item, index) in tipsFormRadioList" :key="index">
            <el-radio
              v-model="tipsFormRadio"
              :label="item"
              @change="tipsFormRadioChange"
            ></el-radio>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendTips">发送</el-button>
        <el-button @click="tipsDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="uname + ' 的学习记录:'"
      :visible.sync="learningRecordDialog"
      width="76%"
      center
      @close="closeLearningRecordDialog"
    >
      <el-table
        :data="learningRecordTable"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#e9eff9' }"
      >
        <el-table-column prop="sectionName" label="章节名称"> </el-table-column>
        <el-table-column label="学习累计时长" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.learnfinish === 0">
              {{ scope.row.truetime }} / {{ scope.row.totaltime }}
            </div>
            <div v-else>
              {{ scope.row.totaltime }} / {{ scope.row.totaltime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="learnfinish" label="学习状态">
          <template slot-scope="scope">
            <div v-if="scope.row.learnfinish === 0">学习中</div>
            <div v-if="scope.row.learnfinish === 1">已学完</div>
            <div v-if="scope.row.learnfinish === 2">已学完</div>
            <div v-if="scope.row.learnfinish > 2">
              {{ scope.row.learnfinish }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <div v-if="scope.row.type === 1">视频</div>
            <div v-if="scope.row.type === 2">音频</div>
            <div v-if="scope.row.type === 3">文本</div>
            <div v-if="scope.row.type === 4">文档</div>
            <div v-if="scope.row.type === 5">音视频链接</div>
          </template>
        </el-table-column>
        <el-table-column prop="starttime" label="开始学习时间">
          <template slot-scope="scope">
            <div v-if="scope.row.starttime !== 0">
              {{ scope.row.starttime | showDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="finishtime" label="完成学习时间">
          <template slot-scope="scope">
            <div v-if="scope.row.finishtime !== 0">
              {{ scope.row.finishtime | showDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="结束学习时间">
          <template slot-scope="scope">
            <div v-if="scope.row.ctime !== 0">
              {{ scope.row.ctime | showDate }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="uname + ' 的考核结果:'"
      :visible.sync="examineResultDialog"
      width="76%"
      class="examine_result_dialog"
      center
      @close="closeExamineResultDialog"
    >
      <learningOutComeFront
        v-if="examineResultDialog"
        :studentUid="studentUid"
      />
    </el-dialog>

    <el-dialog
      :title="uname + ' 的考勤结果:'"
      :visible.sync="attendanceResultDialog"
      width="76%"
      center
      @close="closeAttendanceResultDialog"
    >
      <el-table
        :data="attendanceResultTable"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#e9eff9' }"
      >
        <el-table-column
          v-if="type == 2"
          prop="liveCourseName"
          label="直播课时名称"
        >
        </el-table-column>
        <el-table-column prop="signStatus" label="签到状态"> </el-table-column>
        <el-table-column prop="signCreateDate" label="签到时间">
          <template #default="scope">{{
            scope.row.signCreateDate | datetimeFormat
          }}</template>
        </el-table-column>
        <el-table-column prop="linestarttime" label="签到截止时间">
          <template #default="scope">
            <div v-if="type == 2">
              {{ scope.row.signintime | timeadd(scope.row.signintime) }}
            </div>
            <div v-if="type == 3">
              {{ scope.row.linestarttime | timeadd2(0) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signOutStatus" label="签退状态">
        </el-table-column>
        <el-table-column prop="signOutCreateDate" label="签退时间">
          <template #default="scope">{{
            scope.row.signOutCreateDate | datetimeFormat
          }}</template>
        </el-table-column>
        <el-table-column prop="lineuptime" label="签退截止时间">
          <template #default="scope">
            <div v-if="type == 2">
              {{ scope.row.signouttime | timeadd(scope.row.signouttime) }}
            </div>
            <div v-if="type == 3">
              {{ scope.row.lineuptime | timeadd2(scope.row.signouttime) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import learningOutComeFront from '../LearningOutcome/Learning-outcome-front.vue'
import * as api from '@/api/mySchooling/studentAdmin'
import { formatDate } from '@/utils/common'
export default {
  components: {
    learningOutComeFront,
  },
  data() {
    return {
      type: this.$route.query.type,
      courseId: this.$route.query.courseId,
      courseName: '',
      coverSrc: '',
      count: 0,
      courseStudentList: [],
      uname: '',
      tipsDialog: false,
      superintendent: {
        courseId: this.$route.query.courseId,
        fromUid: localStorage.getItem('uid'),
        uid: '',
        content: '',
      },
      tipsFormRules: {
        content: [{ required: true, message: '请输入提醒语', trriger: 'blur' }],
      },
      tipsFormRadio: '',
      tipsFormRadioList: ['备选1', '备选2'],
      learningRecordDialog: false,
      learningRecordTable: [],
      examineResultDialog: false,
      examineResultTable: [],
      studentUid: '',
      attendanceResultDialog: false,
      attendanceResultTable: [],
      orderBy: '',
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
    }
  },
  created() {
    this.getCourseScoreInfo()
    this.getCourseStudentList()
  },
  filters: {
    // 时间格式化
    showDate(value) {
      let date = new Date(value * 1000)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    timeadd: function (value1, value2) {
      if (!value1) {
        return ''
      }
      let newTime = parseInt(value1)
      // return new Date(parseInt(newTime) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');
      function add0(m) {
        return m < 10 ? '0' + m : m
      }
      var time = new Date(newTime * 1000)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      return (
        y +
        '-' +
        add0(m) +
        '-' +
        add0(d) +
        ' ' +
        add0(h) +
        ':' +
        add0(mm) +
        ':' +
        add0(s)
      )
    },
    timeadd2: function (value1, value2) {
      let newTime = parseInt(value1) + parseInt(value2) * 60
      // return new Date(parseInt(newTime) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');
      function add0(m) {
        return m < 10 ? '0' + m : m
      }
      var time = new Date(newTime * 1000)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      return (
        y +
        '-' +
        add0(m) +
        '-' +
        add0(d) +
        ' ' +
        add0(h) +
        ':' +
        add0(mm) +
        ':' +
        add0(s)
      )
    },
  },
  methods: {
    async getCourseScoreInfo() {
      const courseId = this.courseId
      const type = this.type
      const { code, data } = (await api.getCourseScoreInfo({ courseId, type }))
        .data
      if (code === 100000) {
        this.courseName = data.courseName
        this.count = data.count
        this.coverSrc = data.url
      }
    },
    getCourseStudentList() {
      if (this.type == 1) {
        this.getCourseScore()
      } else if (this.type == 2) {
        this.getLiveCourse()
      } else if (this.type == 3) {
        this.getOfflineCourses()
      }
    },
    // 获取点播课学员列表
    async getCourseScore() {
      const courseId = this.courseId
      const orderBy = this.orderBy
      const { code, data } = (
        await api.getCourseScore({ courseId, orderBy, ...this.pageObj })
      ).data
      if (code === 100000) {
        this.courseStudentList = data.list.map((item) => {
          item.id = item.uid + item.ctime
          if (item.finalScore === null) {
            item.width = 0
            item.finalScore = '--'
          } else {
            item.width = +item.finalScore
            if (item.width >= 0 && item.width < 50) {
              item.color = '#d10009'
              item.isFailScore = true
            } else if (item.width >= 50 && item.width < 60) {
              item.color = '#feff1c'
            } else if (item.width >= 60 && item.width < 100) {
              item.color = '#76b719'
            } else if (item.width === 100) {
              item.color = '#4092f7'
            }
          }
          return { ...item }
        })
        this.total = data.total
      }
    },
    //获取直播课学员列表
    async getLiveCourse() {
      const courseId = this.courseId
      const { code, data } = (
        await api.getLiveCourse({ courseId, ...this.pageObj })
      ).data
      if (code === 100000) {
        this.courseStudentList = data.list
        this.total = data.total
      }
    },
    //获取直播课学员列表
    async getOfflineCourses() {
      const courseId = this.courseId
      const { code, data } = (
        await api.getOfflineCourses({ courseId, ...this.pageObj })
      ).data
      if (code === 100000) {
        this.courseStudentList = data.list
        this.total = data.total
      }
    },
    //获取考勤结果
    async getSignByUid(type, uid) {
      const courseId = this.courseId
      const page = 1
      const pageSize = 20

      const { code, data } = (
        await api.getSignByUid({
          courseId,
          type,
          uid,
          page,
          pageSize,
        })
      ).data
      if (code === 100000) {
        this.attendanceResultTable = data.list
        this.attendanceResultDialog = true
      }
    },
    sendTips() {
      this.$refs.tipsForm.validate(async (valid) => {
        if (valid) {
          const { code, msg } = (await api.superintendent(this.superintendent))
            .data
          if (code === 100000) {
            this.$message.success(msg)
            this.tipsDialog = false
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    tipsTextareaChange(val) {
      if (this.tipsFormRadioList.includes(val)) {
        this.tipsFormRadio = val
      } else {
        this.tipsFormRadio = ''
      }
    },
    tipsFormRadioChange(val) {
      this.superintendent.content = val
    },
    showTipsDialog(uname, uid) {
      this.uname = uname
      this.superintendent.uid = uid
      this.tipsDialog = true
    },
    closeTipsDialog() {
      this.$refs.tipsForm.resetFields()
      this.tipsFormRadio = ''
    },
    async showLearningRecordDialog(uname, uid) {
      this.uname = uname
      const courseId = this.courseId
      const { code, data } = (await api.getLearnRecord({ courseId, uid })).data
      if (code === 100000) {
        this.learningRecordTable = data.list.map((item) => {
          item.totaltime = this.secondsFormat(item.totaltime)
          if (item.truetime !== null) {
            item.truetime = this.secondsFormat(
              item.truetime.split(',').filter((item2) => item2 === '1').length
            )
          } else {
            item.truetime = '00时00分00秒'
          }
          return { ...item }
        })
        this.learningRecordDialog = true
      }
    },
    closeLearningRecordDialog() {
      this.learningRecordTable = []
    },
    showExamineResultDialog(uname, uid) {
      this.uname = uname
      this.studentUid = uid
      this.examineResultDialog = true
    },
    closeExamineResultDialog() {
      this.examineResultTable = []
    },
    showAttendanceResultDialog(uname, uid) {
      this.uname = uname
      let type = 1
      if (this.type == 2) {
        type = 2
      }
      this.getSignByUid(type, uid)
    },
    closeAttendanceResultDialog() {
      this.attendanceResultTable = []
    },
    sortByProgress() {
      if (this.orderBy !== 'descs' && this.orderBy !== 'ascs') {
        this.orderBy = 'descs'
      } else if (this.orderBy === 'descs') {
        this.orderBy = 'ascs'
      } else if (this.orderBy === 'ascs') {
        this.orderBy = ''
      }
      this.getCourseScore()
    },
    sortByScore() {
      if (this.orderBy !== 'desc' && this.orderBy !== 'asc') {
        this.orderBy = 'desc'
      } else if (this.orderBy === 'desc') {
        this.orderBy = 'asc'
      } else if (this.orderBy === 'asc') {
        this.orderBy = ''
      }
      this.getCourseScore()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseScore()
    },
    // 秒转时分秒
    secondsFormat(value) {
      var secondTime = parseInt(value) // 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60)
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result =
        '' +
        (parseInt(secondTime) < 10
          ? '0' + parseInt(secondTime)
          : parseInt(secondTime))

      // if (minuteTime > 0) {
      result =
        '' +
        (parseInt(minuteTime) < 10
          ? '0' + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ':' +
        result
      // }
      // if (hourTime > 0) {
      result =
        '' +
        (parseInt(hourTime) < 10
          ? '0' + parseInt(hourTime)
          : parseInt(hourTime)) +
        ':' +
        result
      // }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  .course {
    display: flex;
    margin-bottom: 14px;
    .left {
      margin-right: 26px;
      img {
        display: block;
        width: 176px;
        height: 98px;
      }
    }
    .right {
      .info {
        display: flex;
        margin-top: 10px;
      }
    }
  }

  .student {
    background-color: #fff;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      height: 42px;
      border-bottom: 1px solid #e5e5e5;
      .title {
        font-size: 20px;
      }
    }

    .stu_list {
      padding: 0 10px;
      .stu_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 102px;
        border-bottom: 1px solid #e5e5e5;
        .left {
          display: flex;
          align-items: center;
          height: 100%;
          .pic {
            margin-right: 24px;
            width: 72px;
            // height: 58px;
          }
          .info {
            font-size: 14px;
            color: #aaa;
            .time {
              color: #bbb;
              margin-top: 10px;
            }
          }
        }

        .right {
          width: 164px;
          .top {
            display: flex;
            justify-content: space-around;
            .score {
              .num {
                font-size: 18px;
              }
            }
            .tips {
              font-size: 18px;
              font-weight: 700;
              color: #4092f7;
              cursor: pointer;
            }
          }

          .mid {
            width: 100%;
            border: 1px solid #000;
            margin-bottom: 8px;
            /deep/ .el-progress-bar__outer {
              border-radius: 0;
              .el-progress-bar__inner {
                border-radius: 0;
              }
            }
          }
          .failScore {
            border: 1px solid #f00;
          }
          .bottom {
            display: flex;
            justify-content: flex-end;
            font-size: 14px;
            color: #39bed5;
            .learning_record {
              cursor: pointer;
            }
            .examine_result {
              margin-left: 14px;
              cursor: pointer;
            }
          }

          .attendance_result {
            margin-top: 30px;
            text-align: right;
            color: #39bed5;
            cursor: pointer;
          }
        }
      }
    }

    .el-pagination {
      text-align: center;
      background-color: #fff;
      /deep/ .el-pager {
        .active {
          background-color: #39bed5;
        }
      }
    }
  }

  .examine_result_dialog {
    .mainDiv {
      margin-top: 0;
      padding: 0;
    }
  }
}
</style>
